import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT, IDLE, PENDING } from "const"
import {
    SilDevice,
    SilProjectDevice,
} from "server/models"
import { StateType, hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_SIL_DEVICE,
    StoreType,
    SilDeviceProps,

    LoadSilDeviceById,

    setSilUpdateDeviceTargetDevice,
    setSilUpdateDeviceOriginDevice,
    initSilProjectDevice,
} from "client/store"

import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import Form from "./form"

import CreateOriginQidDevice from "../originQidDevice"

const SilUpdateDevice = ({
    deviceId = null,
}: SilDeviceProps) => {
    const targetDevice = useSelector((state: StoreType) => state.silUpdate.device.targetDevice)
    const project = useSelector((state: StoreType) => state.project.projectView)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        LoadSilDeviceById(deviceId, userData.accountId, project.id).then((device) => {
            // target device
            const projectDevice = device as SilProjectDevice
            dispatch(setSilUpdateDeviceTargetDevice(projectDevice))

            // origin device
            let accountDevice: SilDevice = null
            let qidOriginDevice: SilProjectDevice = null

            let originDevice: SilProjectDevice = { ...initSilProjectDevice }

            const promiseArray: Promise<any>[] = []
            if (projectDevice.deviceId) {
                promiseArray.push(
                    LoadSilDeviceById(projectDevice.deviceId, userData.accountId, null)
                    .then((res) => { accountDevice = res as SilDevice }),
                )
            }
            if (projectDevice.qidProductId) {
                promiseArray.push(
                    CreateOriginQidDevice(
                        projectDevice.qidProductId,
                        projectDevice.qidModelId,
                        projectDevice.qidSafetyFunctionId,
                        projectDevice.qidOptionId,
                        projectDevice.qidDatapointId,
                        projectDevice.qidMethod,
                    ).then((res) => { qidOriginDevice = res.projectDevice }),
                )
            }

            Promise.all(promiseArray).then(() => {
                if (projectDevice.qidProductId) {
                    originDevice = qidOriginDevice
                } else if (accountDevice) {
                    originDevice = {
                        ...originDevice,
                        name: accountDevice.name,
                        manufacturer: accountDevice.manufacturer,
                        description: accountDevice.description,
                        reference: accountDevice.reference,
                        logoId: accountDevice.logoId,
                        logo: accountDevice.logo,

                        type: accountDevice.type,
                        lowDemandMode: accountDevice.lowDemandMode,
                        highDemandMode: accountDevice.highDemandMode,
                        continuousMode: accountDevice.continuousMode,
                        logicSolver: accountDevice.logicSolver,
                        provenInUse: accountDevice.provenInUse,

                        failureRate: accountDevice.failureRate,
                        sff: accountDevice.sff,
                        dc: accountDevice.dc,
                        pfd: accountDevice.pfd,
                        pfh: accountDevice.pfh,
                        sil: accountDevice.sil,

                        sd: accountDevice.sd,
                        su: accountDevice.su,
                        dd: accountDevice.dd,
                        du: accountDevice.du,

                        status: accountDevice.status,
                    }
                }

                dispatch(setSilUpdateDeviceOriginDevice(originDevice))
                setLoadState(IDLE)
            })
        })
    }, [])

    const editAccess = !project.id
        ? hasAccess(PRM_SIL_DEVICE, EDIT)
        : hasProjectAccess(PRM_SIL_DEVICE, EDIT)

    if (!editAccess) return <AccessDenied />
    if (!targetDevice) return <NotFound />

    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${targetDevice.name} ${lang.details}`}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <Form />
            </PageContent>
        </Container>
    )
}
export default SilUpdateDevice
